import {gql} from '@apollo/client'

export const GET_ALL_DESPACHOS = gql`
  query listDispatch(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $sale_Client_Id: Float
    $created_Gt: DateTime
    $created_Gte: DateTime
    $created_Lt: DateTime
    $created_Lte: DateTime
  ) {
    listDispatch(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      sale_Client_Id: $sale_Client_Id
      created_Gt: $created_Gt
      created_Gte: $created_Gte
      created_Lt: $created_Lt
      created_Lte: $created_Lte
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          plate
          departureDatetime
          dispatchedBy
          sale {
            client {
              name
            }
          }
          dispatchproductthroughSet {
            edges {
              node {
                id
                quantityDispatch
                product {
                  id
                  name
                  unitType
                }
              }
            }
          }
        }
      }
    }
  }
`

// ONE DISPATCH

export const GET_ONE_DISPATCH = gql`
  query listDispatchs($id: Float) {
    listDispatch(id: $id) {
      edges {
        node {
          id
          created
          plate
          uuid
          departureDatetime
          observations
          dispatchedBy
          invoiceId
          metadata
          sale {
            id
            saleTotal
            invoiceId
            dispatchSet {
              edges {
                node {
                  id
                }
              }
            }
            client {
              id
              name
            }
          }
          user {
            id
            firstName
            lastName
          }
          dispatchproductthroughSet {
            edges {
              node {
                id
                quantityDispatch
                product {
                  id
                  name
                  unitPrice
                  unitType
                  promotion
                }
              }
            }
          }
          delivery {
            totalTravel
            fromLocation
            untilLocation
            responsible
          }
        }
      }
    }
  }
`

/** CREAR */
export const GET_CLIENTS_CREATE_DISPATCH = gql`
  query clientList($id: Float, $statusSale: String, $after: String) {
    clientList(id: $id, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          nit
          postpaidSales
          clientproductpriceSet {
            edges {
              node {
                id
                price
                product {
                  id
                  name
                  unitType
                  unitPrice
                  promotion
                }
              }
            }
          }
          saleSet(status: $statusSale) {
            edges {
              node {
                id
                saleTotal
                saleType
                created
                dispatchSet {
                  edges {
                    node {
                      id
                      dispatchproductthroughSet {
                        edges {
                          node {
                            quantityDispatch
                            product {
                              id
                              name
                            }
                          }
                        }
                      }
                    }
                  }
                }
                saleproductthroughSet {
                  edges {
                    node {
                      id
                      units

                      product {
                        id
                        name
                        unitType
                        unitPrice
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const GET_CANTERAS_CREATE_DISPATCH = gql`
  query quarryList($after: String, $id: Float, $offset: Int) {
    quarryList(after: $after, id: $id, offset: $offset) {
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`
export const GET_PRODUCTS_CREATE_DISPATCH = gql`
  query productList($after: String, $id: Float, $name: String, $offset: Int) {
    productList(after: $after, id: $id, name_Iexact: $name, offset: $offset) {
      edges {
        cursor
        node {
          id
          name
          unitPrice
          unitType
          promotion
        }
      }
    }
  }
`
export const GET_VOLCOS_CREATE_DISPATCH = gql`
  query tranportList($id: Float, $after: String) {
    transportList(id: $id, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          id
          plate
          sizeVolco
        }
      }
    }
  }
`
export const GET_NAMTRIK_FORM = gql`
  query getEntityForms($codename: EntityEnum!) {
    getEntityForms(codename: $codename)
  }
`
